import React, { useState } from 'react';
import Compressor from 'compressorjs';
import Grid from '@mui/material/Grid';
import DragDropFile from 'components/DragDropFileImg';
import * as S from './styles';

function ImageUploading({ isImages = [], setIsImages = () => {} }) {
	const [errorPhoto, setErrorPhoto] = useState(false);
	const [message, setMessage] = useState('');
	const MAX_IMAGES = 3;

	const showAlert = (msg) => {
		setMessage(msg);
		setTimeout(() => setMessage(''), 5000); // Oculta a mensagem após 5 segundos
	};

	const savePhoto = (event) => {
		const extesions = ['png', 'jpeg', 'jpg'];
		const files = Array.from(event.target.files);

		if (isImages.length + files.length > MAX_IMAGES) {
			showAlert(`Você pode adicionar no máximo ${MAX_IMAGES} imagens.`);
			return;
		}

		files.forEach((file) => {
			const isPhoto = extesions.some((ext) => file.name.endsWith(ext));

			if (isPhoto) {
				new Compressor(file, {
					quality: 1,
					maxWidth: 800,
					convertSize: 2000000, // 2MB
					success(blob) {
						const newFile = new File([blob], file.name, { type: file.type || 'image' });

						setErrorPhoto(false);
						setMessage('');
						setIsImages((prev) => [...prev, { file: newFile, preview: URL.createObjectURL(newFile) }]);
					}
				});
			} else {
				setErrorPhoto(true);
			}
		});
	};

	const handleDragChange = (files) => {
		// Verifique se files é um FileList e converta para um array, se necessário
		const filesArray = files instanceof FileList ? Array.from(files) : files;

		if (!Array.isArray(filesArray)) {
			console.error('Expected files to be an array but received:', filesArray);
			return;
		}

		if (isImages.length + filesArray.length > MAX_IMAGES) {
			showAlert(`Você pode adicionar no máximo ${MAX_IMAGES} imagens.`);
			return;
		}

		const extesions = ['image/jpeg', 'image/jpg', 'image/png'];

		filesArray.forEach((file) => {
			const isPhoto = extesions.includes(file.type);

			if (isPhoto) {
				new Compressor(file, {
					quality: 1,
					maxWidth: 800,
					convertSize: 2000000, // 2MB
					success(blob) {
						const newFile = new File([blob], file.name, { type: file.type || 'image/jpeg' });

						setErrorPhoto(false);
						setMessage('');
						setIsImages((prev) => [...prev, { file: newFile, preview: URL.createObjectURL(newFile) }]);
					}
				});
			} else {
				setErrorPhoto(true);
			}
		});
	};

	const handleRemoveImage = (index) => {
		setIsImages((prev) => prev.filter((_, i) => i !== index));
	};

	const images = Array.isArray(isImages) ? isImages : [];

	return (
		<Grid container style={{ alignItems: 'center' }}>
			<Grid item xs={12} mt={2}>
				<p>Imagem do registro:</p>
			</Grid>

			<Grid item xs={12} mt={1} style={{ display: 'flex', alignItems: 'center' }}>
				<DragDropFile
					handleChange={(event) => savePhoto(event)}
					handleDragChange={handleDragChange}
					accept="image/jpeg, image/jpg, image/png"
					isMultiple
				/>
			</Grid>
			{isImages.length > 0 && (
				<Grid item xs={12} mt={2} style={{ display: 'flex', justifyContent: 'end' }}>
					<p>
						{isImages.length}/{MAX_IMAGES} imagens selecionadas
					</p>
					{/* Contador de imagens */}
				</Grid>
			)}
			<Grid item xs={12} mt={2}>
				<div style={{ display: 'flex', flexWrap: 'wrap' }}>
					{images.map((img, index) => (
						<div key={index} style={{ position: 'relative', marginRight: 10 }}>
							<img
								src={img.preview ?? img.signedUrl}
								alt={`Imagem ${index + 1}`}
								style={{ width: 100, height: 100, objectFit: 'cover' }}
							/>
							<button
								type="button"
								onClick={() => handleRemoveImage(index)}
								style={{
									position: 'absolute',
									top: 0,
									right: 0,
									background: 'red',
									color: 'white',
									border: 'none',
									borderRadius: '50%',
									width: 24,
									height: 24,
									cursor: 'pointer'
								}}
							>
								&times;
							</button>
						</div>
					))}
				</div>
			</Grid>

			<Grid item xs={12}>
				{errorPhoto && <S.errorPhoto>Selecione apenas fotos nos formatos: jpeg ou png.</S.errorPhoto>}
				{message && <S.errorPhoto>{message}</S.errorPhoto>}
			</Grid>
		</Grid>
	);
}

export default ImageUploading;
